import React, { PureComponent } from 'react';
import { I18n } from 'react-redux-i18n';

import StringUtil from '../../app/utils/string';

class ImportErrors extends PureComponent {
  render() {
    const { errors = [], title, errorMessage } = this.props;
    if (!errors.length) return null;

    return (
      <div className="clients-errors">
        <hr />

        <h5 className="text-danger">
          <strong>
            {title}
          </strong>
        </h5>

        {errors.map(error => (
          <React.Fragment key={error.line}>
            <p>
              <strong>{`${I18n.t("line")} ${error.line}`}</strong>

              {error && error.types.length && error.types.map((type, index) => (
                <React.Fragment key={`${errorMessage || 'erro'}${index}`}>
                  <br />
                  {`${type.fieldName}`}
                  {type.fieldValue && (': (')}
                  <strong>
                    {type.fieldValue}
                  </strong>
                  {type.fieldValue ? (') ') : ' - '}
                  {errorMessage
                    ? I18n.t(`${errorMessage}${StringUtil.capitalizeFirstLetter(type.erro)}`)
                    : I18n.t(type.erro)
                  }
                </React.Fragment>
              ))}
            </p>
          </React.Fragment>
        ))}
      </div>
    );
  }
}

export default ImportErrors;
